import React, { useState } from "react";
import {
  Typography,
  AppBar,
  Tabs,
  Tab,
  Container,
  Box,
  Skeleton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Alert } from "@material-ui/lab";
import { Titulo } from "../Titulo";
import { useDropboxFolder } from "src/hooks/useDropboxFolder";
import EditarClavesClienteSeleccionado from "./clientes/EditarClavesClienteSeleccionado";
import SociosClienteSeleccionado from "./clientes/SociosClienteSeleccionado";
import PlanesClienteSeleccionado from "./clientes/PlanesClienteSeleccionado";
import ContratosClienteSeleccionado from "./clientes/ContratosClienteSeleccionado";
import CorreosCcClienteSeleccionado from "./clientes/CorreosCcClienteSeleccionado";
import DatosPersonalesClienteSeleccionado from "./clientes/DatosPersonalesClienteSeleccionado";
import { useObtenerClienteEspecificoQuery } from "../../services/accesoClientesApi";
import { useClienteActual } from "src/hooks/useClienteActual";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
    marginBottom: 12,
  },
  margen: {
    marginBottom: 12,
  },
}));

export default function DatosClientes() {
  const { rut } = useClienteActual();
  const classes = useStyles();
  const [value, setValue] = useState(0);

  // RTK Query hook - Reemplaza axios
  const {
    data: cliente,
    isLoading,
    isError,
    error,
  } = useObtenerClienteEspecificoQuery(rut);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Asegurar que existe carpeta en Dropbox para el cliente
  useDropboxFolder(rut ? `/Clientes/${rut}` : null);

  // Loading state
  if (isLoading) {
    return (
      <Container>
        <Titulo>
          <Typography variant="h5">Mis Datos</Typography>
        </Titulo>
        <Box sx={{ width: "100%", mt: 2 }}>
          <Skeleton variant="rectangular" height={48} sx={{ mb: 2 }} />
          <Skeleton variant="rectangular" height={400} />
        </Box>
      </Container>
    );
  }

  // Error state
  if (isError) {
    return (
      <Container>
        <Titulo>
          <Typography variant="h5">Mis Datos</Typography>
        </Titulo>
        <Box sx={{ mt: 2 }}>
          <Alert severity="error">
            Error al cargar los datos del cliente. Por favor, intenta
            nuevamente.
            {error?.data?.message && ` (${error.data.message})`}
          </Alert>
        </Box>
      </Container>
    );
  }

  // No hay datos del cliente
  if (!cliente || !cliente.estado) {
    return (
      <Container>
        <Titulo>
          <Typography variant="h5">Mis Datos</Typography>
        </Titulo>
        <Box sx={{ mt: 2 }}>
          <Alert severity="warning">No se encontraron datos del cliente.</Alert>
        </Box>
      </Container>
    );
  }

  // Render normal cuando hay datos
  return (
    <Container>
      <Titulo>
        <Typography
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            paddingRight: "1rem",
            paddingLeft: "1rem",
          }}
          variant="h5"
        >
          Mis Datos
        </Typography>
      </Titulo>

      <div className={classes.root}>
        <AppBar position="static" color="default">
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            aria-label="full width tabs example"
          >
            <Tab label="Claves Portales" />
            <Tab label="Socios" />
            <Tab label="Plan" />
            <Tab label="Contratos" />
            <Tab label="Correos CC" />
            <Tab label="Datos Personales" />
          </Tabs>
        </AppBar>
      </div>

      {value === 0 && (
        <EditarClavesClienteSeleccionado value={value} cliente={cliente} />
      )}

      {value === 1 && (
        <SociosClienteSeleccionado value={value} cliente={cliente} />
      )}

      {value === 2 && (
        <PlanesClienteSeleccionado value={value} cliente={cliente} />
      )}

      {value === 3 && (
        <ContratosClienteSeleccionado value={value} cliente={cliente} />
      )}

      {value === 4 && (
        <CorreosCcClienteSeleccionado value={value} cliente={cliente} />
      )}

      {value === 5 && (
        <DatosPersonalesClienteSeleccionado value={value} cliente={cliente} />
      )}
    </Container>
  );
}
